import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import useDirty from '@/components/playbook-builder/hooks/use-dirty';
import type { BusinessDataNodeProps } from '@/playbook-builder/playbook-builder.types';
import type { ApplyEditMutation } from '../../../base-node';
import BusinessInfoView from '../../../business-info-view';
import BusinessInfoForm from './information-form';
type InformationSectionProps = {
  node: BusinessDataNodeProps;
  mutation: ApplyEditMutation;
  canEdit: boolean;
};
const InformationSection = t0 => {
  const $ = _c(10);
  const {
    node,
    mutation,
    canEdit
  } = t0;
  const [isEditing, setIsEditing] = useState(false);
  const {
    toggle
  } = useDirty();
  let t1;
  if ($[0] !== isEditing || $[1] !== toggle) {
    t1 = () => {
      toggle("business-info", isEditing);
    };
    $[0] = isEditing;
    $[1] = toggle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isEditing) {
    t2 = [isEditing];
    $[3] = isEditing;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== canEdit || $[6] !== isEditing || $[7] !== mutation || $[8] !== node) {
    t3 = isEditing ? <BusinessInfoForm node={node} onDone={() => setIsEditing(false)} mutation={mutation} /> : <BusinessInfoView node={node} onEdit={() => setIsEditing(true)} canEdit={canEdit} />;
    $[5] = canEdit;
    $[6] = isEditing;
    $[7] = mutation;
    $[8] = node;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default InformationSection;